// src/i18n/locales/zh.js

export default {
  countries: {
    'AF': '阿富汗',
    'AL': '阿尔巴尼亚',
    'DZ': '阿尔及利亚',
    'AD': '安道尔',
    'AO': '安哥拉',
    'AG': '安提瓜和巴布达',
    'AR': '阿根廷',
    'AM': '亚美尼亚',
    'AU': '澳大利亚',
    'AT': '奥地利',
    'AZ': '阿塞拜疆',
    'BS': '巴哈马',
    'BH': '巴林',
    'BD': '孟加拉国',
    'BB': '巴巴多斯',
    'BY': '白俄罗斯',
    'BE': '比利时',
    'BZ': '伯利兹',
    'BJ': '贝宁',
    'BT': '不丹',
    'BO': '玻利维亚',
    'BA': '波斯尼亚和黑塞哥维那',
    'BW': '博茨瓦纳',
    'BR': '巴西',
    'BN': '文莱',
    'BG': '保加利亚',
    'BF': '布基纳法索',
    'BI': '布隆迪',
    'CV': '佛得角',
    'KH': '柬埔寨',
    'CM': '喀麦隆',
    'CA': '加拿大',
    'CF': '中非共和国',
    'TD': '乍得',
    'CL': '智利',
    'CN': '中国',
    'CO': '哥伦比亚',
    'KM': '科摩罗',
    'CG': '刚果',
    'CD': '刚果民主共和国',
    'CR': '哥斯达黎加',
    'CI': '科特迪瓦',
    'HR': '克罗地亚',
    'CU': '古巴',
    'CY': '塞浦路斯',
    'CZ': '捷克',
    'DK': '丹麦',
    'DJ': '吉布提',
    'DM': '多米尼克',
    'DO': '多米尼加共和国',
    'EC': '厄瓜多尔',
    'EG': '埃及',
    'SV': '萨尔瓦多',
    'GQ': '赤道几内亚',
    'ER': '厄立特里亚',
    'EE': '爱沙尼亚',
    'ET': '埃塞俄比亚',
    'FJ': '斐济',
    'FI': '芬兰',
    'FR': '法国',
    'GA': '加蓬',
    'GM': '冈比亚',
    'GE': '格鲁吉亚',
    'DE': '德国',
    'GH': '加纳',
    'GR': '希腊',
    'GD': '格林纳达',
    'GT': '危地马拉',
    'GN': '几内亚',
    'GW': '几内亚比绍',
    'GY': '圭亚那',
    'HT': '海地',
    'HN': '洪都拉斯',
    'HU': '匈牙利',
    'IS': '冰岛',
    'IN': '印度',
    'ID': '印度尼西亚',
    'IR': '伊朗',
    'IQ': '伊拉克',
    'IE': '爱尔兰',
    'IL': '以色列',
    'IT': '意大利',
    'JM': '牙买加',
    'JP': '日本',
    'JO': '约旦',
    'KZ': '哈萨克斯坦',
    'KE': '肯尼亚',
    'KI': '基里巴斯',
    'KP': '朝鲜',
    'KR': '韩国',
    'KW': '科威特',
    'KG': '吉尔吉斯斯坦',
    'LA': '老挝',
    'LV': '拉脱维亚',
    'LB': '黎巴嫩',
    'LS': '莱索托',
    'LR': '利比里亚',
    'LY': '利比亚',
    'LI': '列支敦士登',
    'LT': '立陶宛',
    'LU': '卢森堡',
    'MG': '马达加斯加',
    'MW': '马拉维',
    'MY': '马来西亚',
    'MV': '马尔代夫',
    'ML': '马里',
    'MT': '马耳他',
    'MH': '马绍尔群岛',
    'MR': '毛里塔尼亚',
    'MU': '毛里求斯',
    'MX': '墨西哥',
    'FM': '密克罗尼西亚',
    'MD': '摩尔多瓦',
    'MC': '摩纳哥',
    'MN': '蒙古',
    'ME': '黑山',
    'MA': '摩洛哥',
    'MZ': '莫桑比克',
    'MM': '缅甸',
    'NA': '纳米比亚',
    'NR': '瑙鲁',
    'NP': '尼泊尔',
    'NL': '荷兰',
    'NZ': '新西兰',
    'NI': '尼加拉瓜',
    'NE': '尼日尔',
    'NG': '尼日利亚',
    'MK': '北马其顿',
    'NO': '挪威',
    'OM': '阿曼',
    'PK': '巴基斯坦',
    'PW': '帕劳',
    'PS': '巴勒斯坦',
    'PA': '巴拿马',
    'PG': '巴布亚新几内亚',
    'PY': '巴拉圭',
    'PE': '秘鲁',
    'PH': '菲律宾',
    'PL': '波兰',
    'PT': '葡萄牙',
    'QA': '卡塔尔',
    'RO': '罗马尼亚',
    'RU': '俄罗斯',
    'RW': '卢旺达',
    'KN': '圣基茨和尼维斯',
    'LC': '圣卢西亚',
    'VC': '圣文森特和格林纳丁斯',
    'WS': '萨摩亚',
    'SM': '圣马力诺',
    'ST': '圣多美和普林西比',
    'SA': '沙特阿拉伯',
    'SN': '塞内加尔',
    'RS': '塞尔维亚',
    'SC': '塞舌尔',
    'SL': '塞拉利昂',
    'SG': '新加坡',
    'SK': '斯洛伐克',
    'SI': '斯洛文尼亚',
    'SB': '所罗门群岛',
    'SO': '索马里',
    'ZA': '南非',
    'SS': '南苏丹',
    'ES': '西班牙',
    'LK': '斯里兰卡',
    'SD': '苏丹',
    'SR': '苏里南',
    'SZ': '斯威士兰',
    'SE': '瑞典',
    'CH': '瑞士',
    'SY': '叙利亚',
    'TJ': '塔吉克斯坦',
    'TZ': '坦桑尼亚',
    'TH': '泰国',
    'TL': '东帝汶',
    'TG': '多哥',
    'TO': '汤加',
    'TT': '特立尼达和多巴哥',
    'TN': '突尼斯',
    'TR': '土耳其',
    'TM': '土库曼斯坦',
    'TV': '图瓦卢',
    'UG': '乌干达',
    'UA': '乌克兰',
    'AE': '阿拉伯联合酋长国',
    'GB': '英国',
    'US': '美国',
    'UY': '乌拉圭',
    'UZ': '乌兹别克斯坦',
    'VU': '瓦努阿图',
    'VA': '梵蒂冈',
    'VE': '委内瑞拉',
    'VN': '越南',
    'YE': '也门',
    'ZM': '赞比亚',
    'ZW': '津巴布韦'
  },
  verification: {
    verifying: '正在验证您的电子邮件...',
    success: '电子邮件验证成功！',
    failed: '验证失败',
    accountVerified: '您的账户已成功验证。您现在可以登录您的账户。',
    invalidLink: '验证链接无效或已过期。',
    missingToken: '缺少验证令牌。',
    generalError: '验证过程中发生错误。请稍后再试。',
    proceedToLogin: '继续登录',
    backToLogin: '返回登录'
  },
  admin: {
    huduma: 'Genie AI',
    dashboard: '仪表板',
    system: '系统',
    settings: '设置',
    overview: '概述',
    database: '数据库',
    logs: '日志',
    userManagement: '用户管理',
    security: '安全',
    systemAdministration: '系统管理',
    loading: '加载中...',
    close: '关闭',
    edit: '编辑',
    systemUptime: '系统运行时间',
    avgResponseTime: '平均响应时间',
    errorRate: '错误率',
    activeUsers: '活跃用户',
    monthlyActiveUsers: '月活跃用户 (MAU)',
    fromLastMonth: '比上月',
    today: '今天',
    // --- UPDATED TABS ---
    tabs: {
      overview: '系统健康',
      hierarchy: '知识层级', // NEW
      documents: '文档管理', // NEW
      database: '数据库',
      logs: '日志',
      security: '安全',
      users: '用户'
    },
    // --- NEW KEYS ---
    contentManagement: "内容管理",
    knowledgeHierarchy: "知识层级",
    documentManagement: "文档管理",
    noLogsFound: "今天未找到日志",
    invalidLogsResponse: "无效的日志摘要响应结构",
    logsSummaryError: "加载日志摘要失败",
    buttons: {
      save: "保存",
      cancel: "取消",
      switch: "仍然切换",
      discard: "放弃"
    },
    confirm: {
      defaultTitle: "确认",
      defaultMessage: "您确定吗？"
    },
    // --- END NEW KEYS ---
    systemHealthStatus: '系统健康状态',
    runDiagnostics: '运行诊断',
    resourceUsage: '资源使用',
    services: {
      apiServices: 'API 服务',
      database: '数据库',
      cache: '缓存',
      storage: '存储',
      messageQueue: '消息队列',
      externalApi: '外部 API'
    },
    resources: {
      cpu: 'CPU 使用',
      memory: '内存使用',
      storage: '存储使用',
      network: '网络带宽'
    },
    databaseManagement: '数据库管理',
    reindexDatabase: '重新索引数据库',
    lastReindex: '上次重新索引',
    databaseSize: '数据库大小',
    totalTables: '总表数',
    logManagement: '日志管理',
    rolloverLogs: '日志轮转',
    searchLogs: '搜索日志',
    logTime: '时间',
    logLevel: '级别',
    logService: '服务',
    logMessage: '消息',
    showingEntries: '显示 {start}-{end} 共 {total} 条目',
    logLevels: {
      error: '错误',
      warn: '警告',
      info: '信息',
      debug: '调试'
    },
    logMessages: {
      connectionTimeout: '外部提供商连接超时',
      lowDiskSpace: '磁盘空间低于 10% 阈值',
      userRoleUpdated: '用户角色更新为 admin@huduma.ai'
    },
    userName: '姓名',
    userEmail: '电子邮件',
    userRole: '角色',
    userStatus: '状态',
    userActions: '操作',
    roleAdministrator: '管理员',
    roleUser: '用户',
    statusActive: '活跃',
    dbActions: {
      reindex: '重新索引',
      backup: '备份',
      optimize: '优化',
      reindexDesc: '重建数据库索引',
      backupDesc: '创建数据库备份',
      optimizeDesc: '优化查询性能'
    },
    operations: {
      reindexTitle: '数据库重新索引结果',
      backupTitle: '数据库备份结果',
      optimizeTitle: '数据库优化结果',
      reindexResults: '重新索引结果',
      optimizeResults: '优化结果',
      collection: '集合',
      status: '状态',
      indexSuggestions: '索引建议',
      backupDetails: '备份详情',
      backupFile: '备份文件',
      backupLocation: '位置',
      backupSize: '大小',
      errorDetails: '错误详情',
      close: '关闭',
      resultsTitle: '操作结果',
      reindexDatabase: {
        success: '数据库重新索引成功完成',
        error: '数据库重新索引过程中出错',
        loading: '正在重新索引数据库...'
      },
      backupDatabase: {
        success: '数据库备份成功完成',
        error: '数据库备份过程中出错',
        loading: '正在备份数据库...'
      },
      optimizeDatabase: {
        success: '数据库优化成功完成',
        error: '数据库优化过程中出错',
        loading: '正在优化数据库...'
      },
      rolloverLogs: {
        success: '日志轮转成功完成',
        loading: '正在轮转日志...'
      },
      searchLogs: {
        success: '日志搜索完成',
        loading: '正在搜索日志...'
      },
      runDiagnostics: {
        success: '诊断成功完成',
        loading: '正在运行诊断...'
      },
      runSecurityScan: {
        success: '安全扫描成功完成',
        loading: '正在运行安全扫描...'
      },
      cancel: '取消',
      save: '保存更改'
    },
    userManagementSection: {
      totalUsers: '总用户',
      newUsers: '新用户 (月)',
      searchUsers: '搜索用户...',
      clearSearch: '清除搜索',
      search: '搜索',
      usersFound: '找到的用户',
      showAllUsers: '显示所有用户',
      searching: '搜索中...',
      searchingUsers: '正在搜索用户...',
      noUsersFound: '未找到符合搜索条件的用户。',
      noUsers: '无可用用户。',
      showing: '显示',
      of: '共',
      previous: '上一页',
      next: '下一页',
      searchFields: {
        all: '所有字段',
        name: '姓名',
        email: '电子邮件',
        role: '角色'
      },
      userSearch: {
        resultsFound: '找到 {total} 个匹配 "{term}" 的用户',
        error: '搜索用户出错'
      }
    },
    logsSection: {
      errorLogs: '错误日志',
      warningLogs: '警告日志',
      noErrorLogs: '今天未记录错误日志。',
      noWarningLogs: '今天未记录警告日志。',
      infoLogsNote: '信息日志未显示在摘要中。使用搜索功能查看所有日志类型。',
      searchResults: '最新搜索结果',
      entriesFound: '找到的条目',
      viewAllResults: '查看所有结果',
      logType: '类型',
      logCount: '计数',
      logTypes: {
        connectionTimeout: '连接超时',
        databaseFailed: '数据库查询失败',
        authFailed: '认证失败',
        lowDiskSpace: '磁盘空间低于阈值',
        slowQuery: '查询性能缓慢',
        rateLimit: '接近速率限制'
      },
      logSearch: {
        noResultsFound: '未找到匹配搜索条件的日志',
        resultsFound: '找到 {count} 条日志条目'
      }
    },
    security: {
      title: '安全监控',
      securityScan: '安全扫描',
      runningSecurityScan: '正在运行扫描...',
      lastSecurityScan: '上次安全扫描',
      vulnerabilitiesFound: '发现的漏洞',
      daysAgo: '天前',
      critical: '严重',
      medium: '中等',
      low: '低',
      failedLoginAttempts: '失败登录尝试 (24h)',
      suspiciousActivities: '可疑活动 (24h)',
      securityRecommendations: '安全建议',
      criticalVulnerabilities: '严重漏洞',
      mediumVulnerabilities: '中等漏洞',
      lowVulnerabilities: '低漏洞',
      authenticationIssues: '认证问题',
      suspiciousActivityLogs: '可疑活动日志',
      securityProbeAttempts: '检测到安全探测尝试',
      sensitiveFileAccess: '检测到访问敏感文件或端点的尝试',
      envFileAccess: '环境文件访问尝试',
      envFileAccessDesc: '检测到访问 .env 文件的尝试',
      gitRepoAccess: 'Git 仓库访问尝试',
      gitRepoAccessDesc: '检测到访问 Git 仓库文件的尝试',
      recommendedAction: '推荐操作',
      rateLimitRecommendation: '考虑实施速率限制、对持久违规者的 IP 阻塞，并确保服务器强化到位。',
      envFileRecommendation: '确保环境文件无法从 Web 目录访问，并且服务器配置正确阻止对敏感文件的访问。',
      gitRepoRecommendation: '确保 .git 目录正确保护且无法从 Web 访问。',
      noVulnerabilitiesFound: '未发现漏洞',
      systemSecure: '您的系统似乎安全。请继续定期监控。',
      loadingScan: '正在加载扫描结果...',
      occurrences: '发生次数',
      firstSeen: '首次出现',
      lastSeen: '最后出现',
      timestamp: '时间戳',
      message: '消息',
      service: '服务',
      type: '类型',
      severity: '严重性',
      url: 'URL',
      matchedTerm: '匹配项',
      lineNumber: '行号',
      lineNumbers: '行号',
      showLess: '显示较少',
      showMore: '显示所有问题',
      // --- NEW KEY ---
      lastScanJustNow: "刚才"
    },
    userEdit: {
      title: '编辑用户',
      loading: '正在加载用户数据...',
      userInfo: '用户信息',
      userId: '用户 ID',
      loginName: '登录名',
      fullName: '全名',
      dob: '出生日期',
      email: '电子邮件',
      emailVerified: '电子邮件已验证',
      verified: '已验证',
      notVerified: '未验证',
      createdAt: '创建时间',
      lastLogin: '上次登录',
      never: '从未',
      accountSettings: '账户设置',
      accountStatus: '账户状态',
      accountEnabled: '账户启用',
      cannotDisableSelf: '您无法禁用自己的账户',
      accountRole: '账户角色',
      adminRole: '管理员角色',
      cannotChangeOwnRole: '您无法更改自己的角色',
      adminActions: '管理员操作',
      verifyEmail: '验证电子邮件',
      resetPassword: '发送密码重置',
      forceLogout: '强制登出',
      failedToLoad: '加载用户数据失败',
      errorLoading: '加载用户数据出错',
      saveSuccess: '用户设置更新成功',
      errorSaving: '保存用户设置出错',
      verifyEmailSuccess: '验证电子邮件发送成功',
      emailVerificationFailed: '发送验证电子邮件失败',
      errorVerifyingEmail: '发送验证电子邮件出错',
      passwordResetSent: '密码重置电子邮件已发送',
      passwordResetFailed: '发送密码重置失败',
      errorSendingReset: '发送密码重置出错',
      logoutForced: '用户已被登出',
      logoutFailed: '强制登出失败',
      errorForcingLogout: '强制登出出错',
      // --- NEW KEY ---
      userUpdated: "用户更新成功"
    },
    // --- NEW OBJECT ---
    hierarchy: {
      title: "知识层级管理 (注意: 始终为英文 - 添加翻译)",
      addCategory: "添加新类别",
      loading: "正在加载层级...",
      addService: "添加服务",
      editCategory: "编辑类别",
      deleteCategory: "删除类别",
      editService: "编辑服务",
      deleteService: "删除服务",
      empty: '未找到类别。点击 "添加新类别" 开始。',
      formTitleCreateCategory: "创建新类别",
      formTitleAddService: '向 "{categoryName}" 添加服务',
      formTitleEditCategory: '编辑类别: "{itemName}"',
      formTitleEditService: '编辑服务: "{itemName}"',
      nameEnLabel: "名称 (英文)",
      translationsTitle: "用于显示的翻译",
      loadingTranslations: "正在加载翻译...",
      selectLang: "选择语言",
      translationPlaceholder: "输入翻译",
      deleteTranslation: "删除翻译",
      addTranslation: "+ 添加翻译",
      saveSuccess: "层级项保存成功。",
      saveError: "保存层级项失败。",
      loadError: "加载知识层级失败。",
      loadTranslationsError: "加载翻译失败。",
      confirmCancelTitle: "未保存的更改",
      confirmCancelEdit: "您有未保存的更改。确定要取消吗？",
      confirmDeleteTitleCategory: "删除类别？",
      confirmDeleteTitleService: "删除服务？",
      confirmDeleteCategory: '您确定要删除类别 "{itemName}" 吗？此操作无法撤销。',
      confirmDeleteService: '您确定要删除服务 "{itemName}" 吗？此操作无法撤销。',
      deleteSuccessCategory: "类别删除成功。",
      deleteSuccessService: "服务删除成功。",
      deleteErrorCategory: "删除类别失败。",
      deleteErrorService: "删除服务失败。",
      duplicateLangError: "翻译中发现重复语言。请移除它们。"
    },
    // --- NEW OBJECT ---
    documents: {
      title: "文档管理",
      addLink: "从链接添加",
      uploadFiles: "上传文件",
      searchPlaceholder: "按文件名搜索...",
      allStatuses: "所有状态",
      statusPending: "待处理",
      statusIngested: "已提取",
      statusRetracted: "已撤回",
      // --- NEW STATUSES ADDED ---
      statusIngesting: "提取中",
      statusError: "提取错误",
      statusWarning: "已提取(有警告)",
      // ---
      ingestSelected: "提取选中项",
      colFileName: "文件名",
      colStatus: "状态",
      colLabels: "标签",
      colUploadDate: "上传日期",
      colSize: "大小",
      loading: "正在加载文档...",
      empty: "未找到文档。",
      loadError: "加载文档失败。",
      confirmIngestTitle: "确认批量提取",
      ingest: "提取",
      confirmIngestSelected: "您确定要提取选中的 {count} 个文件吗？",
      ingestQueuedSuccess: "{count} 个文件已加入提取队列。",
      ingestQueuedError: "批量提取过程中发生错误。",
      uploadSuccessMultiple: "{count} 个文件上传成功。",
      linkSubmitSuccess: '成功爬取并保存 "{fileName}"。',
      actionSuccess: '对文件 {fileId} 的操作 "{action}" 成功。',
      metadataUpdateSuccess: '文件 {fileId} 的元数据已更新。'
    }
  },
  passwordResetConfirm: {
    appTitle: 'Genie AI',
    resetPassword: '创建新密码',
    tokenLabel: '重置令牌',
    tokenPlaceholder: '输入重置令牌',
    validateButton: '验证令牌',
    newPasswordLabel: '新密码',
    newPasswordPlaceholder: '创建新密码',
    confirmNewPasswordLabel: '确认新密码',
    confirmNewPasswordPlaceholder: '确认您的新密码',
    resetButton: '重置密码',
    processing: '正在重置...',
    rememberedPassword: '记住您的密码？',
    backToLogin: '返回登录',
    supportMessage: '需要帮助？联系我们的支持团队',
    passwordRequirements: '密码必须至少8个字符，包括至少1个数字、1个大写字母和1个特殊字符',
    passwordsDoNotMatch: '密码不匹配',
    resetSuccess: '您的密码已成功重置',
    resetFailed: '无法重置密码。请重试。',
    noTokenProvided: '请提供重置令牌',
    expiredToken: '此重置令牌已过期。请请求一个新的。',
    invalidToken: '无效或无法识别的重置令牌',
    validatingToken: '正在验证令牌...',
    redirecting: '正在重定向到登录页面...',
    passwordStrength: '密码强度',
    strengthLabels: {
      veryWeak: '非常弱',
      weak: '弱',
      fair: '一般',
      good: '好',
      strong: '强'
    },
    passwordSuggestions: {
      atLeast8Chars: '使用至少8个字符',
      addUppercase: '添加大写字母',
      addLowercase: '添加小写字母',
      addNumbers: '添加数字',
      addSpecialChars: '添加特殊字符'
    }
  },
  passwordReset: {
    appTitle: 'Genie AI',
    resetPassword: '重置您的密码',
    emailLabel: '电子邮件地址',
    emailPlaceholder: '输入您的电子邮件',
    resetButton: '发送重置链接',
    processing: '正在发送...',
    rememberPassword: '记住您的密码？',
    backToLogin: '返回登录',
    supportMessage: '需要帮助？联系我们的支持团队',
    invalidEmail: '请输入有效的电子邮件地址',
    resetRequestSuccess: '密码重置链接已发送到您的电子邮件',
    resetRequestFailed: '无法发送密码重置链接。请重试。',
    checkEmail: '请检查您的电子邮件以获取进一步指示。'
  },
  register: {
    appTitle: "Genie AI",
    createAccount: "创建新账户",
    username: "用户名",
    usernamePlaceholder: "输入用户名",
    email: "电子邮件",
    emailPlaceholder: "输入您的电子邮件",
    password: "密码",
    passwordPlaceholder: "创建密码",
    confirmPassword: "确认密码",
    confirmPasswordPlaceholder: "确认您的密码",
    acceptTerms: "我接受",
    termsOfService: "服务条款",
    registerButton: "创建账户",
    processing: "处理中...",
    alreadyHaveAccount: "已有账户？",
    loginNow: "登录",
    privacyNotice: "注册即表示您同意我们的服务条款和隐私政策",
    usernameMinLength: "用户名至少3个字符",
    invalidEmail: "请输入有效的电子邮件地址",
    passwordRequirements: "密码至少8个字符，包括至少1个数字和1个大写字母",
    passwordsDoNotMatch: "密码不匹配",
    mustAcceptTerms: "您必须接受服务条款",
    registrationFailed: "注册失败。请重试。",
    usernameExists: "用户名已存在",
    emailExists: "电子邮件已存在",
    registrationSuccess: "注册成功！",
    verificationEmailSent: "验证电子邮件已发送到 {email}",
    checkEmailInstructions: "请检查您的电子邮件并按照指示验证您的账户，然后登录。",
    backToLogin: "返回登录",
    noEmailReceived: "未收到电子邮件？",
    resendVerification: "重新发送验证电子邮件",
    verificationResent: "验证电子邮件已重新发送",
    verificationResendFailed: "重新发送验证电子邮件失败。请重试。",
    usernameInvalidChars: '用户名只能包含字母、数字、下划线、点和连字符',
    networkError: '网络错误。请检查您的连接并重试。'
  },
  login: {
    appTitle: 'Genie AI',
    username: '用户名',
    password: '密码',
    loginButton: '登录',
    or: '或',
    savedAccounts: '保存的账户',
    loginSuccess: '登录成功',
    loginError: '登录失败。请检查您的凭据。',
    googleLogin: '使用 Google 继续',
    facebookLogin: '使用 Facebook 继续',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    noAccount: '没有账户？',
    createAccount: '创建账户',
    registerNow: "现在注册",
    termsAndPolicy: '登录即表示您同意我们的服务条款和隐私政策',
    loggingIn: "正在登录...",
    fieldsRequired: "用户名和密码是必需的",
    invalidCredentials: "无效的用户名或密码",
    tooManyAttempts: "登录尝试过多。请稍后再试。",
    loginFailed: "登录失败。请重试。",
    oauthNotImplemented: "社交登录尚未实现",
    savedLoginNotImplemented: "保存账户登录尚未实现"
  },
  charts: {
    tooltip: {
      title: '日期',
      totalQueries: '总查询',
      uniqueUsers: '唯一用户'
    },
    day: '日',
    noData: '无数据',
    notAvailable: 'N/A',
    topQueries: '热门查询',
    categoryDistribution: '知识领域使用',
    usageTrend: '使用趋势'
  },
  analytics: {
    title: '数据分析与洞察',
    loading: '正在加载分析数据...',
    period: '时间段',
    charts: {
      satisfactionHeatmap: "按知识领域满意度",
      satisfactionSubtitle: "随时间变化的百分比分数"
    },
    timePeriods: {
      week4: "4 周前",
      week3: "3 周前",
      week2: "2 周前",
      week1: "上周",
      current: "当前"
    },
    errors: {
      loading: "加载满意度数据失败。请重试。",
    },
    status: {
      loading: '加载中...',
      noData: '此期间无可用数据',
      error: '加载分析数据失败',
      online: "系统在线",
      offline: "系统离线",
      responseTime: "平均响应时间",
      queueLength: "队列",
      uptime: "运行时间"
    },
    periods: {
      daily: '每日',
      weekly: '每周',
      monthly: '每月',
      allTime: '所有时间'
    },
    metrics: {
      totalQueries: '总查询',
      uniqueUsers: '唯一用户',
      avgResponseTime: '平均响应时间',
      satisfaction: '用户满意度'
    },
    table: {
      rank: '排名',
      query: '查询',
      count: '计数',
      avgTime: '平均时间'
    },
    chartLabels: {
      categories: '领域',
      serviceCategories: '知识领域',
      byUsage: '按使用',
      category: '领域'
    },
    tooltips: {
      selectPeriod: '选择时间段',
      selectDate: '选择日期',
      exportData: '导出数据'
    },
    gauge: {
      historical: '历史趋势',
      vsPrevious: '与上期比较',
      target: '目标'
    },
    ratings: {
      poor: "差",
      average: "平均",
      good: "好",
      excellent: "优秀"
    },
    slower: '更慢',
    faster: '更快',
    percentage: '百分比',
    note: '以下是使用统计和用户反馈摘要。',
    usageStats: '使用统计',
    peakUsers: '峰值并发用户',
    activeChats: '活跃聊天',
    usageTrend: '使用趋势',
    topQueries: '热门查询',
    feedbackSamples: '用户反馈样本',
    close: '关闭',
    chartComingSoon: '交互式图表可视化即将推出...',
    retry: '重试',
    dailyQueries: '每日查询',
    export: '导出数据',
    dateRange: '日期范围',
    startDate: '开始日期',
    endDate: '结束日期',
    rank: '排名',
    query: '查询',
    count: '计数',
    avgTime: '平均时间',
    serviceUsage: '知识领域使用',
    usageTrends: '使用趋势',
    week: '上周',
    month: '上月',
    quarter: '上季度',
    year: '上年',
    uniqueUsers: '唯一用户',
    satisfactionRate: '满意率',
    satisfactionAnalysis: '用户满意度分析'
  },
  brandName: 'Genie AI：您的数字政府助手',
  nav: {
    systemStatus: '系统状态',
    menu: '菜单',
    analytics: '分析',
    userProfile: '用户资料',
    settings: '设置',
    logout: '登出',
    profile: '我的资料',
    toggleSidebar: '切换侧边栏',
    changeLanguage: '更改语言',
    administration: "管理",
    languages: {
      english: '英语',
      french: '法语',
      swahili: '斯瓦希里语'
    }
  },
  systemStatus: {
    title: '服务状态',
    services: '服务',
    operational: '运行中',
    degraded: '降级',
    outage: '中断',
    allOperational: '所有系统',
    someIssues: '一些问题',
    majorIssues: '重大问题',
    checking: '检查中...',
    nextDeadline: '下一个截止日期',
    days: '天',
    viewDetails: '查看详情'
  },
  services: {
    eCitizen: 'eCitizen 门户',
    taxFiling: '报税系统',
    idApplication: 'ID 申请',
    businessReg: '业务注册',
    drivingLicense: '驾照'
  },
  deadlines: {
    taxFiling: '报税截止日期',
    businessRenewal: '营业执照续期',
    idRenewal: '身份证续期',
    vehicleRegistration: '车辆注册截止日期'
  },
  sidebar: {
    governmentServices: '知识领域',
    chatHistory: '聊天历史',
    searchPlaceholder: '搜索知识领域...',
    createFolder: '创建文件夹',
    editFolder: '编辑文件夹',
    folderName: '文件夹名称',
    folderNamePlaceholder: '输入文件夹名称',
    moveChat: '移动聊天',
    moveChatTo: '移动聊天到',
    selectFolder: '选择文件夹',
    deleteChat: '删除聊天',
    deleteChatConfirm: '您确定要删除此聊天吗？',
    deleteChatWarning: '此操作无法撤销。',
    renameChat: "重命名聊天",
    chatTitle: "聊天标题",
    chatTitlePlaceholder: "为此聊天输入标题",
    deleteFolder: "删除文件夹",
    deleteFolderConfirm: "您确定要删除 '{name}' 文件夹吗？",
    chatsMoveWarning: "此文件夹中的所有聊天将移动到默认文件夹。",
    weatherTitle: "天气预报",
    weatherLoading: "正在加载天气数据...",
    weatherError: "无法加载天气数据。请重试。",
    weatherLocationLoading: '正在加载位置...',
    weatherErrorDefault: '无法检索天气数据。',
    weatherGeolocationUnsupported: '您的浏览器不支持地理位置。',
    weatherRefresh: '刷新天气',
    weatherConditions: {
      clear: '晴朗',
      partlycloudy: '局部多云',
      cloudy: '多云',
      overcast: '阴天',
      rain: '雨',
      shower: '阵雨',
      thunderstorm: '雷暴',
      snow: '雪'
    },
    folders: "文件夹",
    emptyFolder: "此文件夹为空。从聊天菜单移动对话到这里。",
    title: '信息与资源',
    noChats: '无最近聊天',
    relatedDocs: '相关文档',
    noDocuments: '无相关文档',
    faq: '常见问题',
    tab: {
      all: '所有聊天',
      folders: '文件夹',
      starred: '星标',
      archived: '归档'
    },
    savedChats: '保存的聊天',
    chats: "聊天",
    allChats: "所有聊天",
    noFolder: "无文件夹",
    starredChats: "星标聊天",
    archivedChats: "归档聊天",
    noStarredChats: "尚未有星标对话。星标一个对话以添加到这里。",
    noArchivedChats: "尚未有归档对话。",
    noSearchResults: '未找到 "{term}" 的对话',
    loadingChats: "正在加载对话...",
    errorLoadingConversations: "加载对话失败。请重试。",
    errorLoadingUser: "用户数据不完整。请重新加载页面。",
    errorNoUser: "缺少用户数据。请重新加载页面。",
    retry: "重试",
    message: "消息",
    messages: "消息",
    created: "创建",
    updated: "更新",
    star: "星标",
    unstar: "取消星标",
    archive: "归档",
    chatStarred: "对话已星标",
    chatUnstarred: "对话已取消星标",
    chatArchived: "对话已归档",
    chatUnarchived: "对话已取消归档",
    errorUpdatingChat: "更新对话失败",
    chatRenamed: "对话重命名成功",
    errorRenamingChat: "重命名对话失败",
    chatDeleted: "对话删除成功",
    errorDeletingChat: "删除对话失败",
    chatMoved: "对话移动成功",
    errorMovingChat: "移动对话失败",
    noPreview: "无预览可用",
    searchConversations: '搜索对话...',
    selectFolderInstruction: "选择文件夹以查看其对话",
    folderCreated: "文件夹创建成功",
    errorCreatingFolder: "创建文件夹失败",
    errorLoadingFolders: "加载文件夹失败",
    folderUpdated: "文件夹更新成功",
    errorUpdatingFolder: "更新文件夹失败",
    folderDeleted: "文件夹删除成功",
    errorDeletingFolder: "删除文件夹失败",
    chatRemovedFromFolders: "从文件夹移除对话",
    errorRemovingChat: "从文件夹移除对话失败",
    id: "ID",
    labels: "标签",
    confidence: "信心",
    unknown: "未知"
  },
  leftPanel: {
    cat1: {
      name: '1. 身份与民事登记',
      children: ['出生证明', '国民身份证', '护照', '结婚和死亡证明', '选民登记']
    },
    cat2: {
      name: '2. 医疗与社会服务',
      children: ['公共医疗访问', '疫苗接种计划', '医疗保险', '残疾福利', '福利和食品援助']
    },
    cat3: {
      name: '3. 教育与学习',
      children: ['公立学校和大学', '奖学金和学生贷款', '成人教育计划', '在线学习资源']
    },
    cat4: {
      name: '4. 就业与劳动服务',
      children: ['求职和失业福利', '工人保护和劳动权利', '工作场所安全规定', '技能培训和学徒制']
    },
    cat5: {
      name: '5. 税收与收入',
      children: ['所得税申报和退款', '财产税支付', '商业税合规', '海关和进口关税']
    },
    cat6: {
      name: '6. 公共安全与司法',
      children: ['警察和紧急服务', '法院和法律援助服务', '犯罪报告', '消费者保护法']
    },
    cat7: {
      name: '7. 交通与流动性',
      children: ["驾照和车辆登记", '公共交通和基础设施', '交通违规和罚款', '道路安全计划']
    },
    cat8: {
      name: '8. 住房与城市发展',
      children: ['公共住房援助', '财产登记和土地记录', '住房贷款和补贴', '分区和建筑许可']
    },
    cat9: {
      name: '9. 公用事业与环境',
      children: ['水电服务', '废物管理和回收', '环境法规', '可再生能源举措']
    },
    cat10: {
      name: '10. 商业与贸易',
      children: ['商业登记和许可', '贸易法规和许可', '小企业补助和激励', '电子商务和数字商业支持']
    },
    cat11: {
      name: '11. 社会保障与养老金',
      children: ['退休福利', '养老金基金管理', '幸存者福利', '残疾养老金']
    },
    cat12: {
      name: '12. 社区与公民参与',
      children: ['投票和选举', '公众反馈和公民投诉', '志愿和社区计划', '地方政府参与']
    }
  },
  settings: {
    title: '设置',
    save: '保存',
    close: '关闭',
    saveSettings: '保存设置',
    savingSettings: "正在保存您的设置...",
    settingsSaved: "设置保存成功！",
    saveSuccess: '设置保存成功',
    saveError: '保存设置出错',
    display: '显示',
    displayLanguage: '显示语言',
    languages: {
      english: '英语',
      french: '法语',
      swahili: '斯瓦希里语'
    },
    theme: '主题',
    themes: {
      light: '浅色',
      dark: '深色',
      system: '系统'
    },
    fontSize: '字体大小',
    notifications: '通知',
    emailUpdates: '电子邮件更新',
    soundNotifications: '声音通知',
    accountManagement: '账户管理',
    emailAddress: '电子邮件地址',
    emailAddressPlaceholder: '您的电子邮件地址',
    password: '密码',
    changePassword: '更改密码',
    resetUserData: '重置用户数据',
    resetUserDataDesc: '这将清除您的所有资料数据和聊天历史。',
    deleteAccount: '删除账户',
    deleteAccountDesc: '这将永久删除您的账户和所有相关数据。',
    edit: '编辑',
    standardAccount: '标准账户',
    confirmEmailChange: '确认电子邮件更改',
    pleaseEnterPassword: '请输入您的密码',
    cancel: '取消',
    account: {
      title: '账户',
      resetDescription: '这将清除您的所有资料数据和聊天历史。',
      confirmReset: '您确定要重置所有数据吗？这无法撤销。',
      resetComplete: '您的数据已重置。'
    },
    language: {
      title: '语言',
      selectLabel: '显示语言'
    },
    appearance: {
      title: '外观',
      lightTheme: '浅色',
      darkTheme: '深色',
      systemTheme: '系统'
    },
    confirmDeleteAccount: '您确定要删除您的账户吗？此操作无法撤销。',
    confirmAccountDeletion: '确认账户删除',
    accountDeletionWarning: '警告：此操作是永久性的，无法撤销。您的数据将被永久删除。',
    deletionReason: '删除原因（可选）：',
    deletionReasonPlaceholder: '是什么让您决定删除账户？',
    enterPasswordConfirm: '输入您的密码以确认：',
    currentPasswordPlaceholder: '您的当前密码',
    deleting: '正在删除...',
    permanentlyDeleteAccount: '删除账户',
    accountDeletedSuccess: '您的账户已成功删除。',
    incorrectPassword: '密码不正确',
    accountDeletionFailed: '删除账户失败。请稍后再试。',
    confirmChange: '确认更改',
    processing: '处理中...',
    userDataReset: '您的资料数据已成功重置。',
    failedToResetUserData: '重置您的资料数据失败。请稍后再试。',
    changingEmailTo: '将您的电子邮件更改为',
    will: '将',
    logOutSystem: '将您从系统中注销',
    sendVerificationLink: '向您的新电子邮件发送验证链接',
    requireVerification: '在您再次登录前需要验证',
    checkNewEmailVerification: '请检查您的新电子邮件以获取验证指示。',
    unableToVerifyEmail: '无法验证电子邮件。请重试。',
    emailAlreadyInUse: '电子邮件已在使用中',
    enterValidEmail: '请输入有效的电子邮件地址',
    failedToUpdateEmail: '更新电子邮件失败。请重试。',
    passwordResetInitiated: '密码重置链接已发送到您的电子邮件地址。',
    unableToLoadUser: '无法加载用户信息。请重试。',
    retry: '重试',
    user: '用户',
    loadingUserInfo: '正在加载用户信息...',
    resetUserDataTitle: "重置用户数据",
    confirmResetUserData: "您确定要重置所有资料数据吗？这将清除您的所有资料信息和聊天历史，但保留您的账户凭据。",
    reset: "重置",
    deleteAccountTitle: "删除账户"
  },
  userProfile: {
    title: '用户资料',
    privacyInfo: "通过提供更多信息，您将从聊天机器人获得更准确和有意义的响应。请查看我们的",
    privacyPolicyLink: '隐私政策',
    tabComingSoon: '此选项卡正在开发中，即将可用。',
    saveSuccess: '资料保存成功',
    loadError: '加载资料数据出错',
    saveError: '保存资料出错',
    confirmSaveTitle: "保存资料",
    confirmSave: "您确定要保存这些更改吗？",
    confirmCancel: '您有未保存的更改。您确定要取消吗？',
    confirmLeave: '您确定要离开吗？任何未保存的更改将丢失。',
    confirmDiscardChanges: '丢弃未保存的更改？',
    uploadPhoto: '上传照片',
    uploadFile: '上传文件',
    photoRequirements: '照片必须清晰、最近，并显示您的全脸',
    biometricRequirements: '仅接受官方生物识别数据文件',
    documentUpload: '文档上传',
    validationTitle: '请更正以下错误：',
    profileIcon: '资料图标',
    change: '更改',
    chooseProfileIcon: '选择资料图标',
    presetIcons: '预设图标',
    upload: '上传',
    initials: '首字母',
    clickToUpload: '点击上传',
    useThisImage: '使用此图像',
    useInitials: '使用首字母',
    tabs: {
      tab1: '个人识别数据',
      tab2: '民事登记与文档',
      tab3: '地址与居住信息',
      tab4: '身份与旅行文档',
      tab5: '健康与医疗记录',
      tab6: '就业与经济数据',
      tab7: '教育与学术记录',
      tab8: '财务与税务数据',
      tab9: '社会保障与福利',
      tab10: '犯罪与法律记录',
      tab11: '交通与流动性',
      tab12: '公民与政治参与'
    },
    actions: {
      cancel: '取消',
      save: '保存资料',
      previous: '上一页',
      next: '下一页',
      saving: '保存中...'
    },
    fields: {
      fullName: '全名（包括别名）',
      dob: '出生日期',
      gender: '性别',
      nationality: '国籍',
      maritalStatus: '婚姻状态',
      photograph: '照片',
      biometric: '指纹 / 生物识别数据',
      birthCert: '出生证明',
      deathCert: '死亡证明',
      marriageDivorce: '结婚 / 离婚记录',
      adoption: '收养记录',
      citizenship: '公民 / 入籍文档',
      immigration: '移民与签证历史',
      currentAddress: '当前居住地址',
      previousAddresses: '以前地址',
      postalCode: '邮政编码',
      country: '国家',
      residencyStatus: '居住状态',
      homeOrRental: '房屋所有权或租赁详情',
      utilityBills: '与地址链接的公用事业账单',
      landRecords: '土地和财产所有权记录',
      idCard: '国民身份证号码',
      passport: '护照详情',
      driversLicense: "驾照",
      voterId: '选民 ID',
      ssn: '社会保障 / 国家保险号码',
      militaryRecords: '军事服务记录',
      medicalHistory: '医疗历史和健康状况',
      vaccinations: '疫苗记录',
      insuranceDetails: '医疗保险详情',
      disability: '残疾状态',
      bloodType: '血型',
      organDonor: '器官捐赠状态',
      prescriptions: '处方和接受的治疗',
      mentalHealth: '心理健康历史',
      eHistory: '就业历史',
      currentEmployer: '当前雇主详情',
      workPermits: '工作许可和劳动合同',
      certifications: '专业认证和许可证',
      unemployment: '失业状态和收到的福利',
      tin: '纳税人识别号 (TIN)',
      businessAffiliations: '企业所有权和公司关联',
      schools: '就读的学校和大学',
      education: '教育',
      degrees: '文凭、学位和认证',
      performance: '学术表现和考试分数',
      academicRecords: "学术记录",
      scholarships: '收到的奖学金和财政援助',
      incomeTax: '所得税记录',
      bankAccounts: '银行和金融账户',
      propertyTax: '财产税支付',
      businessTax: '商业税申报',
      pensionContrib: '养老金贡献和提款',
      loanAid: '贷款和政府援助记录',
      pensionStatus: '养老金状态和贡献',
      childcare: '儿童护理支持',
      foodAssistance: '食品援助 / 福利计划',
      housingAssistance: '住房援助',
      policeRecords: '警察记录（犯罪历史、逮捕、指控）',
      courtCases: '法院案件历史',
      finesPenalties: '罚款和处罚',
      paroleProbation: '假释或缓刑状态',
      citizenshipRevocation: '公民撤销（如果适用）',
      vehicleReg: '车辆登记详情',
      trafficViolations: '交通违规和罚款',
      licenseHistory: '驾照历史和背书',
      publicTransportCard: '公共交通卡使用',
      voterRegistration: '选民登记详情',
      electionHistory: '选举参与历史',
      partyMembership: '政党成员资格',
      militaryStatus: '军事服务或征兵状态',
      publicServiceRoles: '公共服务角色'
    },
    placeholders: {
      fullName: '输入您的法定全名',
      nationality: '输入您的国籍',
      searchCountries: '搜索国家...',
      selectCountry: '选择国家',
      searchDisciplines: "搜索学科...",
      selectDiscipline: "选择学科",
      searchDegrees: "搜索学位...",
      selectDegree: "选择学位"
    },
    validation: {
      nameRequired: '全名是必需的',
      dobRequired: '出生日期是必需的',
      dobFuture: '出生日期不能是未来日期',
      requiredField: '{field} 是必需的',
      invalidFormat: '{field} 的格式无效',
      futureDate: '日期不能是未来日期',
      invalidSelection: '请进行有效选择',
      passwordLength: '密码必须至少8个字符',
      matchError: '字段不匹配'
    },
    errors: {
      savingFailed: '保存资料失败',
      loadingFailed: '加载资料数据失败',
      invalidForm: '请填写所有必需字段',
      invalidFileType: '无效的文件类型',
      fileTooLarge: '文件太大',
      countryLoadError: '加载国家出错',
      countryUpdateError: '更新国家出错'
    },
    notifications: {
      saveSuccess: '资料保存成功',
      saveFailed: '保存资料失败',
      loadSuccess: '资料加载成功',
      loadFailed: '加载资料失败',
      fieldRequired: '此字段是必需的',
      uploadSuccess: '文件上传成功',
      uploadFailed: '文件上传失败',
      formChanged: '您有未保存的更改',
      sessionExpired: '您的会话已过期，请重新登录',
      profileUpdated: '您的资料已更新',
      profileIncomplete: '您的资料不完整'
    },
    instructions: {
      fullNameHelp: '输入您的法定全名，如官方文档所示',
      dobHelp: '以 MM/DD/YYYY 格式输入您的出生日期',
      uploadPhotoHelp: '上传最近照片。文件必须是 JPG、PNG 或 GIF，且小于 2MB',
      passwordHelp: '密码必须至少8个字符，包括一个大写字母、一个数字和一个特殊字符',
      documentHelp: '接受格式：PDF、JPG、PNG（最大 5MB）',
      requiredFields: '标有 * 的字段是必需的',
      selectFromList: '请从列表中选择一个选项',
      nextTab: '继续到下一节',
      previousTab: '返回上一节',
      saveInstructions: '点击保存以存储您的信息',
      cancelInstructions: '点击取消以丢弃更改'
    },
    completionStatus: {
      notStarted: '未开始',
      inProgress: '进行中',
      complete: '完成',
      percentComplete: '{percent}% 完成',
      tabsCompleted: '{completed} / {total} 节完成',
      tabComplete: '选项卡完成！'
    },
    gender: {
      male: '男',
      female: '女',
      other: '其他',
      preferNot: '不愿透露'
    },
    maritalStatus: {
      single: '单身',
      married: '已婚',
      divorced: '离婚',
      widowed: '丧偶',
      other: '其他'
    },
    residencyStatuses: {
      citizen: '公民',
      permanentResident: '永久居民',
      temporaryResident: '临时居民',
      other: '其他'
    },
    employmentStatuses: {
      employed: '就业',
      selfEmployed: '自雇',
      unemployed: '失业',
      student: '学生',
      retired: '退休',
      homemaker: '家庭主妇/夫',
      other: '其他'
    },
    educationLevels: {
      primary: '小学教育',
      secondary: '中学教育',
      highSchool: '高中',
      vocational: '职业培训',
      associate: '副学士学位',
      bachelor: '学士学位',
      master: '硕士学位',
      doctoral: '博士学位',
      professional: '专业学位',
      other: '其他'
    },
    proficiencyLevels: {
      native: '母语',
      fluent: '流利',
      advanced: '高级',
      intermediate: '中级',
      basic: '基础'
    },
    bloodTypes: {
      aPositive: 'A+',
      aNegative: 'A-',
      bPositive: 'B+',
      bNegative: 'B-',
      abPositive: 'AB+',
      abNegative: 'AB-',
      oPositive: 'O+',
      oNegative: 'O-',
      unknown: '未知'
    },
    languages: {
      english: '英语',
      french: '法语',
      swahili: '斯瓦希里语',
      arabic: '阿拉伯语',
      spanish: '西班牙语',
      portuguese: '葡萄牙语',
      chinese: '中文',
      japanese: '日语',
      german: '德语',
      russian: '俄语',
      hindi: '印地语',
      urdu: '乌尔都语',
      other: '其他'
    },
    yesNo: {
      yes: '是',
      no: '否'
    },
    select: '请选择',
    existingFile: '现有文件',
    noMatchingCountries: '未找到匹配的国家',
    noMatchingDisciplines: "未找到匹配的学科",
    noMatchingDegrees: "未找到匹配的学位",
    educationOptions: [
      "会计", "航空工程", "农业科学", "人类学", "建筑",
      "艺术史", "人工智能", "天文学", "天体物理学", "生物化学",
      "生物医学工程", "生物技术", "工商管理", "化学工程",
      "化学", "土木工程", "通信", "计算机工程", "计算机科学",
      "建筑管理", "刑事司法", "网络安全", "数据科学", "牙科",
      "经济学", "教育", "电气工程", "小学教育", "英国文学",
      "环境工程", "环境科学", "时尚设计", "电影研究",
      "金融", "美术", "食品科学", "法医学", "游戏设计",
      "地理", "地质学", "平面设计", "卫生管理", "历史",
      "酒店管理", "人力资源", "工业设计", "工业工程", "信息系统",
      "信息技术", "室内设计", "国际商务", "国际关系",
      "新闻学", "法律", "图书馆学", "语言学", "管理", "营销",
      "材料科学", "数学", "机械工程", "媒体研究", "医学",
      "气象学", "微生物学", "音乐", "纳米技术", "护理", "营养",
      "职业治疗", "海洋学", "石油工程", "药学", "哲学",
      "摄影", "体育教育", "物理治疗", "物理", "政治学",
      "心理学", "公共管理", "公共卫生", "公共关系", "机器人",
      "中学教育", "社会工作", "社会学", "软件工程", "特殊教育",
      "体育管理", "统计学", "系统工程", "戏剧艺术", "旅游",
      "城市规划", "兽医学", "网页开发", "野生生物学", "动物学"
    ],
    degreeOptions: [
      "副学士学位", "文学学士 (BA)", "理学学士 (BS)", "工程学学士 (BEng)",
      "工商管理学士 (BBA)", "美术学士 (BFA)", "教育学学士 (BEd)",
      "医学学士 (MBBS)", "法学学士 (LLB)", "文学硕士 (MA)", "理学硕士 (MS)",
      "工商管理硕士 (MBA)", "工程学硕士 (MEng)", "美术硕士 (MFA)",
      "教育学硕士 (MEd)", "法学硕士 (LLM)", "公共卫生硕士 (MPH)",
      "哲学博士 (PhD)", "医学博士 (MD)", "教育博士 (EdD)",
      "工商管理博士 (DBA)", "法学博士 (JD)", "专业文凭",
      "技术文凭", "职业证书", "研究生证书", "研究生文凭", "博士后"
    ],
    aria: {
      tabList: '资料表单部分',
      nextButton: '转到下一节',
      prevButton: '转到上一节',
      closeButton: '关闭资料表单',
      saveButton: '保存资料数据',
      requiredField: '必需字段',
      dropdownSelect: '选择选项'
    }
  },
  chatbot: {
    placeholder: '在此输入您的查询...',
    sendButton: '发送',
    fileReceived: '文件接收成功。',
    fileUploadError: '上传文件出错。',
    processingError: '处理您的请求出错。',
    timeoutError: '服务器响应时间比平时更长。请稍后再试。',
    welcomeMessage: 'Welcome to UPB! How can I assist you with university services today?',
    attachFile: '附加文件',
    fileTooLarge: '文件太大。最大大小为 {maxSize}。',
    saveChat: '保存聊天',
    chatSaved: '聊天已保存',
    chatTitle: '聊天标题',
    chatTitlePlaceholder: '为此聊天输入标题',
    selectFolder: '选择文件夹',
    newChat: '新聊天',
    clearContext: '清除上下文并开始新对话',
    unsavedChanges: '您有未保存的更改。您确定要开始新聊天吗？',
    whatCanIHelp: "今天我能帮您什么？",
    justChat: "只是聊天",
    queryContext: "查询上下文",
    contextAdded: '上下文添加到您的查询',
    contextRemoved: '上下文从您的查询移除',
    sessionUpdated: '会话更新',
    newChatStarted: '开始新对话',
    loadError: '无法加载聊天历史',
    responsePrefix: "我收到了您的消息",
    withContext: "带有上下文",
    conversationLoaded: "对话加载成功！",
    saveConfirmTitle: "保存现有对话",
    saveConfirmMessage: "保存现有对话？",
    loadConfirmTitle: "加载现有对话",
    loadConfirmMessage: "您有未保存的更改。您要丢弃它们并加载选定的对话，还是先保存当前对话？",
    loadAndDiscard: "加载并丢弃",
    saveAndLoad: "保存并加载",
    saveAndStartNew: "保存并开始新",
    discardAndStartNew: "丢弃并开始新",
    newChatTitle: "开始新聊天",
    exportChat: '导出聊天',
    exportFilename: '文件名',
    exportFilenamePlaceholder: '输入文件名',
    exportButton: '导出',
    exportSuccess: '聊天导出成功',
    exportError: '导出聊天失败。请重试。'
  },
  quickhelp: {
    applyForID: "申请ID",
    payTaxes: "缴税",
    startBusiness: "创业",
    findHealthcare: "医疗服务",
    educationServices: "教育服务",
    transportLicenses: "交通与许可",
    housingPrograms: "住房计划",
    findJobs: "找工作",
    justChat: "聊聊天",
    justChatPrompt: "我想聊聊政府服务",
    applyForIDPrompt: "我需要关于如何申请居民身份证的信息",
    payTaxesPrompt: "在线缴税的过程是什么？",
    startBusinessPrompt: "指导我完成开创新事业的步骤",
    findHealthcarePrompt: "哪里可以找到公共医疗服务的信息？",
    educationServicesPrompt: "What academic services are available for students at UPB?",
    transportLicensesPrompt: "如何续签我的驾照？",
    housingProgramsPrompt: "Tell me about student housing options and residence halls at UPB",
    findJobsPrompt: "目前有哪些政府工作机会？"
  },
  common: {
    cancel: '取消',
    create: '创建',
    save: '保存',
    move: '移动',
    delete: '删除',
    // --- NEW KEYS ADDED ---
    ok: '确定',
    ingest: '提取',
    retract: '撤回',
    loading: '加载中...',
    refresh: '刷新'
  },
  feedback: {
    title: '反馈',
    button: '反馈',
    positive: '积极反馈',
    negative: '负面反馈',
    promptText: '此响应是否有帮助？',
    placeholder: '额外评论...',
    submit: '提交反馈',
    close: '取消',
    thankYouMessage: '感谢您的反馈！',
    submitting: '提交中...',
    error: '出了点问题。请重试。',
    success: '感谢您的反馈！',
  },
  responseRating: {
    title: '帮助我们改进',
    note: '您的反馈将用于更好地调整聊天机器人并随着时间改善响应。',
    chatbotResponse: '聊天机器人响应：',
    ratingLabels: {
      1: '无用',
      2: '略有帮助',
      3: '中等帮助',
      4: '非常有帮助',
      5: '改变生活'
    },
    additionalComments: '额外评论...',
    submit: '提交',
    cancel: '取消'
  },
  upload: {
    alt: '上传'
  },
  details: {
    loading: '正在加载文件详细信息...',
    title: '文件详情',
    close: '关闭',
    fileName: '文件名',
    author: '作者',
    labels: '标签',
    selectAll: '全选',
    loadingLabels: '正在加载标签...',
    status: '状态',
    fileId: '文件ID',
    fileType: '文件类型',
    viewFile: '查看文件',
    visitLink: '访问外部链接',
    openFile: '在新标签页中打开文件',
    fileSize: '文件大小',
    uploadDate: '上传日期',
    hash: 'SHA256 哈希值',
    // --- NEW: TABS ---
    tabs: {
      details: "详情",
      ingestionLog: "提取日志"
    },
    // --- NEW: LOG TAB ---
    log: {
      killActions: "终止操作:",
      killDocument: "终止此文档",
      killProcess: "终止提取过程",
      timestamp: "时间戳",
      level: "级别",
      stage: "阶段",
      message: "消息",
      loadingLogs: "正在加载日志...",
      noLogs: "未找到日志。"
    },
    buttons: {
      saveMetadata: '保存元数据',
      retract: '撤回',
      ingest: '提取'
    },
    notifications: {
      loadError: '加载文件详细信息失败。',
      validationError: '文件名和作者为必填项。',
      saveSuccess: '元数据更新成功。',
      saveError: '保存元数据失败。',
      tokenError: '在用户数据中未找到身份验证令牌。',
      viewError: '无法加载文件进行查看。',
      ingestSuccess: '文件已成功排队等待提取。',
      ingestError: '启动提取过程失败。',
      retractSuccess: '文件已成功撤回。',
      retractError: '撤回文件失败。',
      deleteSuccess: '文件删除成功。',
      deleteError: '删除文件失败。',
      // --- NEW NOTIFICATIONS ---
      ingestLabelRequired: "提取前请至少选择一个标签。",
      ingestSaving: "提取前正在保存元数据...",
      ingestSaveFailed: "保存元数据失败。提取已取消。",
      logError: "获取提取日志失败。",
      killDocSent: "已发送此文档的终止请求。",
      killProcSent: "已发送提取过程的终止请求。"
    },
    confirm: {
      ingest: '您确定要提取此文件吗？这将启动数据处理流程。',
      retract: '您确定要撤回此文件吗？',
      delete: '您确定要永久删除此文件吗？此操作无法撤销。',
      // --- NEW CONFIRMATIONS ---
      ingestTitle: "确认提取",
      retractTitle: "确认撤回",
      deleteTitle: "确认删除",
      killDocTitle: "终止文档提取",
      killDoc: "您确定要终止此文档的提取任务吗？系统将尝试安全回滚。",
      killProcTitle: "终止所有提取过程",
      killProc: "警告：这将终止整个后端提取服务，影响当前正在处理的所有文件。您确定吗？"
    }
  },
  uploadDialog: {
    title: '上传文件',
    dropzone: '将文件拖放到此处，或点击选择',
    allowedTypesLabel: '允许类型:',
    buttonUpload: '上传 {count} 个文件', // Needs pluralization rules
    remove: '移除',
    uploading: '上传中...',
    notifications: {
      dropError: '只能拖放文件。请检查您是否从计算机拖动了有效文件。',
      typeNotAllowed: '不允许的文件类型 "{extension}"。',
      shortcutUnsupported: '不支持快捷方式文件 (.url)。请拖动实际文件。',
      duplicate: '文件 "{fileName}" 已添加。',
      uploadSuccess: '成功上传 {fileName}',
      uploadFailed: '上传 {fileName} 失败。'
    }
  }
}